import React from "react";
import "./MainTitle.css";

export const MainTitle = ({ children }) => (
  <h1 className="main-title primary">{children}</h1>
);
